import { z } from 'zod'

const isoDateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?Z$/

// Supports Date JS dates and ISO strings.
const hybridDateSchema = z.union([
  z.date(),
  z.string()
    .refine(str => isoDateRegex.test(str), {
      message: 'Invalid ISO date format',
    })
    .transform(str => new Date(str)),
])

export const shiftExpenseSchema = z.object({
  id: z.coerce.number().optional(),
  shift_id: z.coerce.number().positive('Shift ID must be a positive number'),
  amount: z.coerce.number().min(0, 'Amount must be a non-negative number'),
  notes: z.string().optional().nullable(),
  created_at: hybridDateSchema,
  updated_at: hybridDateSchema.optional(),
  business_id: z.string().uuid(),

  // Legacy field (keep for existing data)
  expense_type: z.string().optional(),

  // New field (preferred) - references expense_types.id
  expense_id: z.coerce.number().positive().optional(),

  // Money source the expense was taken from - references fund_sources.id.
  // Required moving forward; legacy rows in the DB may be null.
  fund_source_id: z.coerce.number().positive('Please select a valid fund source'),
})
  .refine(data => data.expense_type || data.expense_id, {
    message: 'Either expense_type or expense_id must be provided',
    path: ['expense_type'],
  })

export const updateShiftExpenseSchema = z.object({
  id: z.coerce.number().optional(),
  shift_id: z.coerce.number().positive('Shift ID must be a positive number'),
  amount: z.coerce.number().min(0, 'Amount must be a non-negative number'),
  notes: z.string().optional().nullable(),
  business_id: z.string().uuid(),

  // Legacy field (keep for existing data)
  expense_type: z.string().optional(),

  // New field (preferred) - references expense_types.id
  expense_id: z.coerce.number().positive().optional(),

  // Money source the expense was taken from - references fund_sources.id.
  // Required moving forward; legacy rows in the DB may be null.
  fund_source_id: z.coerce.number().positive('Please select a valid fund source'),
})
  .refine(data => data.expense_type || data.expense_id, {
    message: 'Either expense_type or expense_id must be provided',
    path: ['expense_type'],
  })

export const expenseResponseSchema = z.object({
  success: z.boolean(),
  total: z.number(),
  data: z.array(shiftExpenseSchema),
})

export type ShiftExpense = z.infer<typeof shiftExpenseSchema>
export type ExpenseResponse = z.infer<typeof expenseResponseSchema>
